import { Controller } from "@hotwired/stimulus"

// Simple controller to open modals by ID (CSP-compliant)
export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    // Controller connected
  }

  open(event) {
    event.preventDefault()
    
    const modalId = this.targetValue.replace('#', '') // Remove # if present
    const modal = document.getElementById(modalId)
    
    if (modal) {
      modal.classList.remove("hidden")
      document.body.style.overflow = "hidden"
    } else {
      console.error(`Modal with ID "${modalId}" not found`)
    }
  }
}

